'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const SparklesIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.8818 14C16.1369 15.0457 14.0456 17.137 13 19.8818C11.9543 17.137 9.86301 15.0457 7.11816 14C9.86301 12.9543 11.9543 10.863 13 8.11816C14.0456 10.863 16.1369 12.9543 18.8818 14Z",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.86736 8.5541C7.3222 9.06915 5.94873 10.4426 5.43368 11.9878C4.91863 10.4426 3.54515 9.06915 2 8.5541C3.54515 8.03905 4.91863 6.66558 5.43368 5.12042C5.94873 6.66558 7.3222 8.03905 8.86736 8.5541Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.4739 4.06021C11.6154 4.40358 10.757 5.09031 10.4137 6.12042C10.0703 5.09031 9.21181 4.40358 8.35339 4.06021C9.3835 3.71684 10.0703 2.85842 10.4137 2C10.757 2.85842 11.6154 3.54516 12.4739 4.06021Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpSparklesIcon = forwardRef(SparklesIcon);

export { VpSparklesIcon as default };
